import styled from 'styled-components';
import { CampaignType } from '../../CreateCampign.styles';

export const ProductName = styled.p`
    display: inline-block;
    margin: 0 0 0 ${({ theme }) => theme.spacing * 6}px;
    color: ${({ theme }) => theme.colors.blue};
    font-weight: bold;
    font-size: 14px;
`;

export const StyledCampaignType = styled(CampaignType)`
    margin: 0 0 ${({ theme }) => theme.spacing * 3}px;
    &.moreProducts {
        cursor: default;
        opacity: .54;
    }
`;
